import _ from 'underscore';
import { CWGererActiviteWorflowActifModel } from './cwGererActiviteWorflowActif.model';
import { CWPaginatedCollection } from 'src/core/models/cwPaginated.collection';


/**
 * Collection of Type d'evénements
 */
export class CWGererActiviteWorkflowActifColl extends CWPaginatedCollection<CWGererActiviteWorflowActifModel>{

  canViewTreatment: boolean;

  constructor(models?: CWGererActiviteWorflowActifModel[] | { [key: string]: any }[] | any, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(models)) {
      options = models;
    }
    options = options || {};
    options.model = options.model || CWGererActiviteWorflowActifModel;
    super(models, options);
    this.canViewTreatment = true;
    this.url = (): string => {
      return Configuration.restRoot + "/rest/assocircuitevt/type";
    };
    this.sortings = { libelle: true };
    this.paginated = false;
  }
}